<template>
    <v-footer app id="footer" location="bottom" color="grey" elevation="0" class="mt-0">
        <v-row justify="center" no-gutters>

            <router-link v-show="!$vuetify.display.mobile" :to="item.link" v-for="item in this.linkStore.footerLinks"
                :key="item.id">
                <v-btn color="white" variant="text" class="mx-2" rounded="xl">
                    {{ item.title }}
                </v-btn>
            </router-link>

            <v-col class="text-center mt-4" cols="12">
                {{ new Date().getFullYear() }} — <strong>Joking Heroes' Maine Coons @ <u><a
                            href="https://www.freesenkatten.eu/">Freesenkatten e.V.</a></u></strong>
            </v-col>
        </v-row>
    </v-footer>
</template>

<script>
import { useLinkStore } from "../store/links"

export default {
    setup() {
        const linkStore = useLinkStore();
        return { linkStore };
    },
    data: () => ({
        links: [
            'Zuchtfreunde',
            'Wissenswertes',
            'Dokumente', // Zertifikate und Auszeichnungen
            'Datenschutz',
            'Impressum',
        ],
    }),
}
</script>

<style>
#footer {
    padding-bottom: 0.5em;
    padding-top: 0.5em;
}
</style>
